import type { HessianClient } from '$lib/client/hessianClient.svelte';
import { getContext, setContext } from 'svelte';

const HESSIAN_CLIENT_CONTEXT_KEY = Symbol('hessianClient');

export const setHessianClientContext = (getClient: () => HessianClient) => {
	setContext(HESSIAN_CLIENT_CONTEXT_KEY, getClient);
};

export const getHessianClientContext = () => {
	return getContext<() => HessianClient>(HESSIAN_CLIENT_CONTEXT_KEY)();
};
